import { useStore } from '@/store/useStore';
import { isNativeGlsExperimentEnabled } from '@/utilities/helpers/wrapperHelpers';

const ENABLED_EXPERIMENT_VALUES = new Set([
  'enabled',
  'on',
  'treatment',
  'true',
]);

export const getEnabledExperiments = (
  experiments: Record<string, unknown> | null | undefined,
): string[] =>
  Object.keys(experiments ?? {})
    .filter((key) => {
      const variant = experiments?.[key];
      const value =
        variant && typeof variant === 'object' && 'value' in variant
          ? (variant as { value?: unknown }).value
          : variant;

      return (
        value === true ||
        (typeof value === 'string' &&
          ENABLED_EXPERIMENT_VALUES.has(value.toLocaleLowerCase()))
      );
    })
    .sort();

/**
 * Stable, allowlisted context shared by RUM logs/actions and duration vitals.
 * Keep this intentionally small: never add response bodies, tokens, balances,
 * preferences, or complete Zustand slices.
 */
export const buildTelemetryContext = (): Record<string, unknown> => {
  const { runtime, userSessionContext, gameContext, amplitudeExperiments } =
    useStore.getState();

  return {
    userId: userSessionContext?.userId ?? null,
    sessionId: userSessionContext?.sessionId ?? null,
    hasActiveSession: userSessionContext?.hasActiveSession ?? false,
    region: gameContext?.region ?? runtime?.region ?? null,
    product: runtime?.product ?? null,
    platform: runtime?.platform ?? null,
    brand: runtime?.brand ?? null,
    channel: runtime?.channel ?? null,
    gameUid: gameContext?.gameUid ?? null,
    gameStudio: gameContext?.gameStudio ?? null,
    gameId: gameContext?.gameId ?? null,
    gameName: gameContext?.gameName ?? null,
    provider: gameContext?.provider ?? null,
    rgi: gameContext?.rgi ?? null,
    gamingSessionTrackingId: gameContext?.gamingSessionTrackingId ?? null,
    enabledExperiments: getEnabledExperiments(amplitudeExperiments),
    nativeGlsExperiment: isNativeGlsExperimentEnabled(),
  };
};
